var path = 'areas/shared/views/selector/choice-user.html';
var html = "<span ng-bind-html=\"item.Username | htmlEscape | highlight: $select.search\"></span> (<span ng-bind-html=\"item.DisplayName | htmlEscape | highlight: $select.search\"></span>)";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/selector/choice-user.html
// module id = 8353040484657271
// module chunks = 1